import { useTranslation } from 'react-i18next';
import { Block, ScannerInput } from '@uni-space/uni-components';
import { getGeParcelLabel } from '../api';
import { useLabelPrinter } from '@shared/labels';

export default function GeLabel() {
  const { t, i18n } = useTranslation();

  const { isLabelLoading, printLabelFromFetcher } = useLabelPrinter({
    errorTitle: t('common.systemError.title'),
    fallbackErrorMessage: t('common.systemError.desc'),
  });

  const handleSubmit = async (value: string) => {
    await printLabelFromFetcher(async () => {
      const blob = await getGeParcelLabel(value);
      // Пустой ответ (204) — этикетки для этого трек-номера нет
      if (!blob.size) throw new Error(t('geLabel.errors.labelNotFound'));
      return blob;
    });
  };

  return (
    <Block mH={8}>
      <ScannerInput
        lang={i18n.language}
        label={t('geLabel.scanner.trackNumber')}
        buttonLabel={t('send')}
        isLoading={isLabelLoading}
        disabled={isLabelLoading}
        onSubmit={handleSubmit}
      />
    </Block>
  );
}
